import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { SavedBrandCollectionsContext } from "contexts/SavedBrandCollections";
import { useContext } from "react";
import { SavedBrandCollection } from "schemas/dashboard";

import Collection from "features/Home/Sidebar/FavoritesList/Collections/SingleCollection";

interface Props {
  open: boolean;
  onClose: () => void;
  onSelect: (collection: SavedBrandCollection) => void;
}

export default function SavedListDialog({ open, onClose, onSelect }: Props) {
  const { collections } = useContext(SavedBrandCollectionsContext);
  const list = Object.values(collections);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: 700,
        }}
      >
        Choose a saved list
        <IconButton size="small" onClick={onClose} aria-label="Close">
          <Box component="i" className="fa-regular fa-xmark" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ maxHeight: "60vh" }}>
        {list.length === 0 ? (
          <Typography sx={{ fontSize: 14, color: "text.secondary", py: 2 }}>
            You don&apos;t have any saved lists yet.
          </Typography>
        ) : (
          list.map((collection) => (
            <Collection
              key={collection.id}
              collection={collection}
              setSelectedCollection={() => onSelect(collection)}
              hideDelete
            />
          ))
        )}
      </DialogContent>
    </Dialog>
  );
}
